import { IQueryTableResult } from "#services/pilotService/responses/types";
import * as uuid from "uuid";
import {
    QueryType,
    TableActionIdentifiers,
    TableActionTypes,
    TablesState,
} from "#store/tables/tableTypes";
import { ErrorState, IoStateEnum } from "#store/types";

/**************************
 * Reducer
 *************************/

export const emptyTableResult: IQueryTableResult = {
    meta: {
        columns: [],
        redundancies: [],
        relevancies: [],
        name: "",
        types: [],
        labels: [],
        redundancyMatrix: [],
        descriptors: [],
        dateformats: [],
        classes: [],
    },
    interpretationId: NaN,
    type: "table",
    queryType: QueryType.SQL,
    data: [],
    sourceQuery: "",
    columns: [],
    tableId: NaN,
};

// The reducer function
export function tablesReducer(
    state: TablesState = {
        query: "",
        pending: [],
        requestId: uuid.NIL,
        tableResults: {},
    },
    action: TableActionTypes
): TablesState {
    switch (action.type) {
        case TableActionIdentifiers.FETCH_TABLE_STARTED: {
            // this action is only persisted on first encounter:
            const currentPayload = state.tableResults[action.payload];
            if (!currentPayload || currentPayload.state !== "fetching") {
                return {
                    ...state,
                    tableResults: {
                        ...state.tableResults,
                        [action.payload]: {
                            payload: null,
                            error: null,
                            state: IoStateEnum.fetching,
                            timestamp: new Date(),
                        },
                    },
                };
            } else {
                return state;
            }
        }
        case TableActionIdentifiers.FETCH_TABLE_SUCCEEDED: {
            const key = action.payload.tableId;
            return {
                ...state,
                tableResults: {
                    ...state.tableResults,
                    [key]: {
                        payload: action.payload,
                        error: null,
                        state: IoStateEnum.done,
                        timestamp: new Date(),
                    },
                },
            };
        }
        case TableActionIdentifiers.FETCH_TABLE_FAILED: {
            return {
                ...state,
                tableResults: {
                    ...state.tableResults,
                    [action.payload.id]: {
                        payload: null,
                        error: action.payload,
                        state: "error",
                        timestamp: new Date(),
                    } as ErrorState,
                },
            };
        }
        default: {
            return state;
        }
    }
}
